<div class="flex w-full justify-center items-center mt-20 text-sm">
  <div class="bg-white drop-shadow-xl rounded-lg w-full py-4 px-4 lg:w-2/6">
    <h2 class="font-bold text-2xl mb-2 text-center">Free Palestine</h2>
    Israel is killing tens of thousands of palestinian civilians and displacing millions more. It's a genocide. Please help defend their freedom and Palestine's right to exist.
  </div>
</div>
